/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_No_RecordInputs */



/**
* | output |
* | --- |
* | "Notetaker off" |
*
* @param {Meetings_Exception_No_RecordInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_no_record = /** @type {((inputs?: Meetings_Exception_No_RecordInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_No_RecordInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker uit")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notetaker désactivé")
	return /** @type {LocalizedString} */ ("Notetaker off")
});